<template>
<!-- 
默认模式type:drag
按钮样式type:select,
带有剪切功能 cropper:true
图片也当做普通文件上传 onlyFile: true

剪切功能参数 cropperOption
不传裁剪的默认参数如下：
size:0.9,//压缩比例
fixedBox:true,//固定框
cropWidth:210,//裁剪宽
cropHeight:270,//裁剪高
 -->
<div :class="{'inlineBlock':type=='select'}">
	<Upload
		:show-upload-list="false"
		:before-upload="res=>beforeUpload(res,'confirmation')"
		:max-size="20480"
        :accept="acceptStr"
		action="/" 
        :on-success="handleSuccess"
		:type="type"
		:onlyFile="onlyFile"
		:disabled="disabled"
		style="line-height:30px;" >
		<slot/>
        <template v-if="!$slots.default">
            <span v-if="type=='drag'">{{btnText}}</span>
            <Button icon="ios-cloud-upload-outline" v-else>{{btnText}}</Button>
        </template>
	</Upload>
</div>
</template>
<script>
export default {
	props:{
		type:{
			type:String,
			default:'drag' // drag/select
		},
		btnText:{
			type:String,
			default:'上传'
		},
		cropper:{
			type:Boolean,
			default:false
		},
		onlyFile: {
			type: Boolean,
			default: false
		},
		cropperOption:{
			default(){
				return {}
			}
        },
        accept:{
            type:Array,
            default(){
                return ['image','word','pdf','excel','zip']
            }
        },
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			imageCropperShow:false,
            imageCropperFile:"",
            fileName: '',
            acceptJson:{
                image:'image/*',
                word:'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                pdf:'application/pdf,application/msword',
                excel:'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                zip:'application/zip,application/x-zip,application/x-zip-compressed',
            }
		}
    },
    computed:{
        acceptStr(){
            let str=[];
            this.accept.forEach(item=>{
                this.acceptJson[item]&&str.push(this.acceptJson[item])
            })
            return str.join(',')
        }
    },
	methods:{
		beforeUpload(file){
            // 根据accept校验文件类型
            let isValid = false;
            for(let item of this.accept){
                const acceptType = this.acceptJson[item];
                if(acceptType){
                    const types = acceptType.split(',');
                    for(let type of types){
                        // 处理 image/* 通配符匹配
                        if(type.indexOf('*') > -1){
                            const prefix = type.split('/*')[0] + '/';
                            if(file.type.startsWith(prefix)){
                                isValid = true;
                                break;
                            }
                        }else{
                            // 其他类型精确匹配
                            if(file.type === type){
                                isValid = true;
                                break;
                            }
                        }
                    }
                    if(isValid) break;
                }
            }
            
            if(!isValid){
                this.alert('不支持的文件类型');
                return false;
            }
            
            //如果是图片
            if(file.type.indexOf('image') > -1 && !this.onlyFile) {
				this.ossUpload(file).then(res=>{
					this.$emit("on-success",{
						type:'image',
						...res
					})
				})
            }else {
				if(file.size > 10*1024*1024) {
                    this.alert('文件不得大于10M');
                    return false
                }
				this.ossUpload(file).then(res=>{
					this.$emit("on-success",{
						type:'file',
						...res
					})
					this.$Notice.success({
						title: '系统提示',
						desc: '上传成功'
					});
				})
            }
			return false
        },
        //文件上传成功
        handleSuccess(res) {
        }
	}
}
</script>
<style scoped>
	.inlineBlock{
		display: inline-block;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/common/UploadFileImg.vue